import Button from 'react-bootstrap/Button';
import { useEffect, useState } from 'react';

function BotonGeneral(){ 
        const [isLoading, setLoading] = useState(false);

        useEffect(() => {
            function simulateNetworkRequest() {
            return new Promise((resolve) => setTimeout(resolve, 2000));
            }

            if (isLoading) {
            simulateNetworkRequest().then(() => {
                setLoading(false);
            });
            }
        }, [isLoading]);

        const handleClick = () => setLoading(true);
        
        return (
        <Button 
        variant="primary"
        disabled={isLoading}
        onClick={!isLoading ? handleClick : null}
        >
        {isLoading ? 'Cagando…' : 'Click cargar'}
        </Button>
        );
}

export default BotonGeneral; 